module.exports = __webpack_public_path__ + "b0460ddd8a86337435959cc2610aaeeb.jpg";